import React, { useState } from "react";
import useEmailer from "hooks/useEmailer";
import Modal from "components/Modal";

import SupportHelpIcon from "assets/icons/supportHelp.svg?react";
import SupportEmailIcon from "assets/icons/supportEmail.svg?react";

import styles from "./SupportContact.module.css";

const SupportContact = () => {
    const [onEmail, isSending, isSuccess] = useEmailer();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [emailTo, setEmailTo] = useState("contact@gouspa.org");

    return (
        <>
            <div
                className={styles.supportContact}
                data-testid="support-contact"
            >
                <div className={styles.supportContactContent}>
                    <div className={styles.supportContactIcon}>
                        <SupportEmailIcon />
                    </div>
                    <div className={styles.supportContactText}>
                        <h1>Have A Specific Question?</h1>
                        <p>
                            For any questions or help you might need, please use
                            the live chat on this page between 8am and 6pm EST.
                        </p>
                        {/*<p>
                            Send us an email for any questions or help you might
                            need by clicking the Email Us button below.
                        </p>
                        <button onClick={() => setIsModalOpen(true)}>
                            Email Us
                        </button>*/}
                    </div>
                </div>
            </div>
            <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <h2 className={styles.contactFormTitle}>Contact Us</h2>
                <form
                    className={styles.contactForm}
                    onSubmit={(e) => {
                        e.preventDefault();
                        onEmail({
                            recipients: e.target.recipients.value
                                .split(",")
                                .map((email) => ({
                                    emailAddress: { address: email },
                                })),
                            subject: e.target.subject.value,
                            body: e.target.message.value,
                        });
                    }}
                >
                    <p>Email To:</p>
                    <input
                        type="text"
                        name="recipients"
                        required
                        value={emailTo}
                        onChange={(e) => setEmailTo(e.target.value)}
                    />
                    <p>Subject:</p>
                    <input type="text" name="subject" required />
                    <p>Message:</p>
                    <textarea name="message" rows="5" required></textarea>
                    {isSending ? (
                        <p>Sending...</p>
                    ) : (
                        isSuccess && <p>Email sent!</p>
                    )}
                    <button type="submit">Send</button>
                </form>
            </Modal>
        </>
    );
};

export default SupportContact;
